const doc = [({"da":({"activerecord":({"models":({"log_key":({"one":"Lognøgle", "other":"Lognøgler"})}), "attributes":({"log_key":({"key":"Nøgle"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;